export default {
  // trigger: 'item',
  // formatter: p => {
  //   let txtCon = p.name + ' 签约时间 ' + p.value[2]
  //   return txtCon
  // }
}



// WEBPACK FOOTER //
// ./src/views/home/board/options/tooltip.js